var m = require('mithril');
var prop = require('mithril/stream');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');

var fetchChannelConfigModal = {};

function errorMessage (error) {
  if (!error) return 'Unable to fetch the channel configuration.';
  if (typeof error === 'string') return error;
  var detail = error.error || error.message ||
    error.response && (error.response.cause || error.response.error) ||
    'Unable to fetch the channel configuration.';
  if (typeof detail === 'string') return detail;
  try {
    return JSON.stringify(detail);
  } catch (e) {
    return String(detail);
  }
}

fetchChannelConfigModal.open = function (record, onDone) {
  var running = prop(false);
  var error = prop('');

  function setButtons () {
    modal.vm.buttons([
      {
        label: 'Cancel',
        class: '',
        disabled: running(),
        func: function () { modal.vm.close(); }
      },
      {
        label: running() ? 'Fetching…' : 'Fetch Channel Config',
        class: 'dib red',
        disabled: running(),
        func: submit
      }
    ]);
  }

  function submit () {
    if (running()) return;
    running(true);
    error('');
    setButtons();
    m.redraw();

    return loaders.requestWithLoader({
      url: record['@id'] + '/getConfig/',
      method: 'GET',
      loader: 'submit'
    })
    .then(function (response) {
      modal.vm.close();
      if (typeof onDone === 'function') {
        return onDone(response);
      }
      return response;
    })
    .catch(function (requestError) {
      error(errorMessage(requestError));
      running(false);
      setButtons();
      m.redraw();
    });
  }

  modal.vm.title('Fetch Channel Config?');
  modal.vm.body = function () {
    return m('div', [
      m('div.ba.b--orange.orange.pa3.mb3', [
        m('div.flex.items-start', [
          m('i.ion-alert-circled.f3.mr2', {'aria-hidden': 'true'}),
          m('div', [
            m('div.b.mb2', 'Confirm that the IP-852 configuration server is available before continuing.'),
            m('p.ma0', 'This action clears Nimrod\'s saved channel configuration. Nimrod must reload the configuration from the server before it can continue to read or write network variables.')
          ])
        ])
      ]),
      error() ? m('div.red', error()) : null
    ]);
  };
  setButtons();
  modal.vm.open();
};

module.exports = fetchChannelConfigModal;
